<template>
  <LineChart :options="chartOptions"></LineChart>
</template>

<script>
import LineChart from '@wizer/core/components/chart/LineChart'
import ChartMixin from '@/mixins/ChartMixin'

export default {
  name: 'LineChartWrapper',
  mixins: [ChartMixin],
  components: {
    LineChart,
  },
  created() {
    this.$store.dispatch('setIsFillMissingDates', true)
  },
}
</script>
